module.exports = __webpack_public_path__ + "img/019-bride-of-frankenstein.287b8d32.png";